import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

import { Link, Arrange, Typography } from "@aviary";
import { useStoreAvataxCertificatesInfoQuery } from "@clinic/shared/data/queries/StoreAvataxCertificatesInfoQuery/StoreAvataxCertificatesInfo.query";
import { useCertCaptureEnabled } from "@clinic/shared/hooks/useCertCaptureEnabled/useCertCaptureEnabled";
import { emersonRoutes } from "@emerson/data/emersonRoutes";
import { l } from "@emerson/locales/i18n";
import { AnalyticsEvent } from "@shared/hooks/useAnalyticsLogger/AnalyticsEvent";
import { useAnalyticsLogger } from "@shared/hooks/useAnalyticsLogger/useAnalyticsLogger";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";

import * as styles from "./BecomeTaxExemptNudge.styles";

type Props = {
  numberOfCartItems: number;
};

const BecomeTaxExemptNudge = ({ numberOfCartItems }: Props) => {
  const { t } = useTranslation();
  const logAnalyticsEvent = useAnalyticsLogger();
  const certCaptureEnabled = useCertCaptureEnabled(true);
  const { data, loading: avataxCustomerQueryLoading } = useStoreAvataxCertificatesInfoQuery();

  const hasActiveCertificate = data?.currentStore?.hasUnexpiredWholesaleTaxCertificate;

  if (avataxCustomerQueryLoading || hasActiveCertificate || !certCaptureEnabled) return null;

  const handleClick = () => {
    logAnalyticsEvent({
      eventName: AnalyticsEvent.EMERSON_CART_BECOME_TAX_EXEMPT,
      payload: {
        total_item_count: numberOfCartItems,
      },
    });
  };

  return (
    <Link
      isColor="system"
      to={emersonRoutes.account.taxExemptionCertification}
      onClick={handleClick}
    >
      <Arrange spacing="xsmall" isWrapped={false} css={styles.wrapper}>
        <FontAwesomeIcon icon={faInfoCircle} />
        <Typography css={styles.link}>{t(l.cart.BecomeTaxExempt)}</Typography>
      </Arrange>
    </Link>
  );
};

export { BecomeTaxExemptNudge };
